<template>
  <div>
    <b-modal
        scrollable
      id="add-barcode-direct-existing"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('ArticleNumber')} - ${mainColorArticleName}; Color - ${mainDressCategoryColorIdName} `"
      hide-footer
      @hide="onCancel"
    >
      <b-form-group
        :label="$t('Barcode')"
      >
        <b-form-input
          v-model="barcode"
          :placeholder="$t('Barcode')"
          @input="callCode(barcode)"
        />
        <p
          v-if="getIsCodePersisted == true"
          style="color:red;margin:0px;"
        >
          {{ $t('UniqueCode') }}
        </p>
      </b-form-group>
      <b-form-group
        :label="$t('Size')"
      >
        <vue-select
          v-model="size"
          :placeholder="$t('Size')"
          :options="filteredSizeTypes"
          label="name"
          :reduce="e => e.name"
        />
        <p
          v-if="buttonSubmited && !size"
          style="color:red;"
        >
          {{ $t('This_is_a_required_field') }}
        </p>
      </b-form-group>
      <b-form-group
        :label="$t('PurchasePrice')"
      >
        <b-form-input
          v-model.number="purchasePrice"
          :placeholder="$t('Price')"
          type="number"
        />
      </b-form-group>
      <b-form-group
        :label="$t('SellingPrice')"
      >
        <b-form-input
          v-model.number="sellingPrice"
          :placeholder="$t('Price')"
          type="number"
        />
      </b-form-group>
      <b-form-group
        :label="$t('Description')"
      >
        <b-form-textarea
          v-model="description"
          :placeholder="$t('Description')"
        />
      </b-form-group>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          style="background: #FF274F !important;"
          :disabled="getIsCodePersisted == true"
          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; ; background: white; color: black; border-color: white;font-weight: 400;"

          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['mainDressColorId', 'mainDressId', 'mainColorArticleName', 'mainDressCategoryColorIdName'],
  data() {
    return {
      barcode: null,
      size: null,
      purchasePrice: 0,
      sellingPrice: 0,
      description: null,
      buttonSubmited: false,
      skipWatch: false,
    }
  },
  computed: {
    ...mapGetters(['getProductSize', 'getDressesSize', 'getIsCodePersisted']),
    filteredSizeTypes() {
      if (!this.getDressesSize.length) {
        return this.getProductSize;
      }

      const dressSizes = new Set(this.getDressesSize.map((dress) => { return dress.size }));

      return this.getProductSize.filter((sizeObj) => { return !dressSizes.has(sizeObj.name) });
    },
  },
  watch: {
    purchasePrice(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value < 0 || value == '') {
          this.purchasePrice = 0
        }
      }, 200);
    },
    sellingPrice(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value < 0 || value == '') {
          this.sellingPrice = 0
        }
      }, 200);
    },
  },
  mounted() {
    this.loadSizeTypes()
  },
  methods: {
    ...mapActions(['loadSizeTypes', 'loadCodePersisted']),
    callCode(value) {
      clearTimeout(this.debounceTimeout);

      this.debounceTimeout = setTimeout(() => {
        this.loadCodePersisted({
          code: value,
        });
      }, 300);
    },
    onSubmit() {
      this.buttonSubmited = true
      if (!this.size && this.buttonSubmited) {
        return
      }
      const object = {
        code: this.barcode,
        currency: '€',
        materialVariantDtos: [],
        price: this.sellingPrice,
        purchasePrice: this.purchasePrice,
        sizes: [this.size],
        mainDressCategoryColorId: this.mainDressColorId,
        mainDressCategoryId: this.mainDressId,
        articleName: this.mainColorArticleName,
        description: this.description,
      }
      this.$emit('addBarcode', object)
      this.onReset()
    },
    onCancel() {
      this.onReset()
    },
    onReset() {
      this.barcode = null
      this.size = null
      this.purchasePrice = 0
      this.sellingPrice = 0
      this.description = null
      this.buttonSubmited = false
      this.$store.commit('SET_IS_CODE_PERSISTED', false);
      this.$refs.modal.hide()
    },
  },
}
</script>

      <style lang="scss" scoped>

      </style>
